import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import {RadioGroup, RadioButton, ReversedRadioButton} from 'react-radio-buttons';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import PortletContent from '../../layouts/components/content/Portletcomponents/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';

class MaterialRadioButton extends Component {
    constructor(props) {
    super(props);
        //console.log("filter props", props)
        this.state = {
            list:this.props.list
        }
    }

    onChange = (event) => {
        this.props.infoAutoComplete(event)
    };
    render(){
        const {list} =this.state
        return (
            <RadioGroup onChange={ this.onChange } vertical>
                {list.map(ele=>(
                    <RadioButton value={ele.nombre}>
                        {ele.nombre}
                    </RadioButton>
                ))}
            </RadioGroup>
            
        );

    }
  
}


export default compose(withStyles(styles))(MaterialRadioButton);


// WEBPACK FOOTER //
// ./src/helpers/RadioButton/index.jsx